import React from "react";

const SkillCategory = ({ title, skills }) => {
  return (
    <div className="w-full p-6 md:p-7 lg:p-8">
      <h3 className="font-display font-semibold text-[#8A00D4] text-[18px] md:text-[19px] lg:text-[20px] mb-5">
        {title}
      </h3>
      <div className="flex flex-wrap gap-4">
        {skills.map((skill, index) => (
          <span
            key={index}
            className="px-[14px] py-[6px] font-sans font-normal text-[14px] bg-[#1A1025] text-white rounded-md hover:bg-[#4B006E] transition-all duration-300"
          >
            {skill}
          </span>
        ))}
      </div>
    </div>
  );
};

export default SkillCategory;
